import { ComponentRef, Directive, ElementRef, HostBinding, HostListener, Injector, Input, ViewContainerRef } from '@angular/core';
import { ComponentPortal }                                                                                   from '@angular/cdk/portal';
import { Overlay, OverlayRef }                                                                               from '@angular/cdk/overlay';

import { OverlayService }                       from '../../core/services/overlay.service';
import { LightboxComponent, RED_LIGHTBOX_DATA } from './lightbox/lightbox.component';


@Directive({ selector: '[redLightbox]' })
export class LightboxDirective {

  public lightboxPortal:  ComponentPortal<LightboxComponent>;
  public lightboxOverlay: OverlayRef;

  @Input() public imageUrl: string;
  @Input() public alt:      string;

  @HostBinding('style.cursor')
  public cursor: string = 'zoom-in';

  @HostListener('click', [ '$event' ])
  public handleClick(event: Event) {
    if (event) event.preventDefault();
    this.openLightbox();
  }

  constructor(
    private elementRef:       ElementRef,
    private viewContainerRef: ViewContainerRef,
    private overlay:          Overlay,
    private overlayService:   OverlayService,
  ) {
    this.imageUrl = this.elementRef.nativeElement.src || '';
  }

  public openLightbox() {
    const positionStrategy = this.overlay
                                 .position()
                                 .global()
                                 .centerVertically()
                                 .centerHorizontally();

    const overlayConfig = {
      positionStrategy,
      scrollStrategy:      this.overlay.scrollStrategies.block(),
      disposeOnNavigation: true,
      hasBackdrop:         true,
      backdropClass:       [ 'o-backdrop' ]
    };

    const dataInjector: Injector = this.overlayService.createDataInjector(
      RED_LIGHTBOX_DATA, { imageUrl: this.imageUrl, alt: this.alt }
    );

    this.lightboxPortal = new ComponentPortal(
      LightboxComponent,
      this.viewContainerRef,
      dataInjector
    );

    const componentRef = this.overlayService.open(
      'lightbox', this.lightboxPortal, overlayConfig
    ) as ComponentRef<LightboxComponent>;

    this.lightboxOverlay = this.overlayService.getOverlayRef('lightbox');

    this.lightboxOverlay.backdropClick().subscribe(() => {
      componentRef.instance.close();
    });
  }
}
